import { useEffect, useState } from "react"
import { AvField } from "availity-reactstrap-validation"
import { Row, Col, Card, CardBody, Alert } from "reactstrap"
import { Link } from "react-router-dom"
const BASE_URL = process.env.REACT_APP_BASE_URL

import Application from "services/applications/Application.service"
import ViewAttachments from "components/Application/ViewAttachments"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"
import OfficerChecklistReviewForm from "pages/Application/EnvironmentalAudit/OfficerChecklistReviewForm"
import TinyMCEEditor from "components/RichTextEditor/TinyMCEEditor"

let officerInfo = JSON.parse(localStorage.getItem("authUser"))
let appService = new Application(officerInfo)

const envAuditService = new EnvAuditService(
  JSON.parse(localStorage.getItem("authUser"))
)

const HeadFormEnvAudit = props => {
  const [comments, setcomments] = useState()
  const [showComments, setshowComments] = useState()
  const [showApprovalDuration, setshowApprovalDuration] = useState(false)
  const [showCertificatePreview, setshowCertificatePreview] = useState(false)
  const [applicationPhase, setapplicationPhase] = useState("phase 1")
  const [staffUploads, setstaffUploads] = useState([])

  // checklist review
  const [checklistFormData, setchecklistFormData] = useState({})
  const [questions, setQuestions] = useState([])
  const [existingChecklists, setexistingChecklists] = useState([])
  const [mountChecklists, setmountChecklists] = useState(false)

  // RichText
  const [approvalConditions, setapprovalConditions] = useState("")
  const [mountRichText, setmountRichText] = useState(false)
  const [mountToR, setmountToR] = useState(false)
  const [applicationToR, setapplicationToR] = useState("")

  const [showDraftToRPreview, setshowDraftToRPreview] = useState(false)

  const certPreviewUrl =
    BASE_URL + "verify/certificate/" + props.appDetails.app_id + "?preview=true"

  const finalTorUrl = BASE_URL + "verify/tor/" + props.appDetails.app_id

  const torPreviewUrl =
    BASE_URL + "verify/tor/" + props.appDetails.app_id + "?preview=true"

  useEffect(() => {
    if (props.appDetails.service_id != 1) {
      setshowApprovalDuration(false)
    }
  })

  useEffect(() => {
    console.log(props.appDetails)
    if (props.appDetails.is_application_in_phase_2) {
      setapplicationPhase("phase 2")
    }
    if (props.appDetails.approval_conditions != null) {
      setapprovalConditions(props.appDetails.approval_conditions)
      // console.log("conditions --->", props.appDetails.approval_conditions)
    }
    if (props.appDetails.application_tor != null) {
      setapplicationToR(props.appDetails.application_tor)
    }
    setmountToR(true)
    setmountRichText(true)
    getApplicationAttachments()
    fetchReviewQuestions()
    fetchApplicationCheckList()
  }, [])

  const fetchReviewQuestions = () => {
    envAuditService.getAllChecklistQuestions().then(response => {
      //   console.log("questions -----> ", response);
      if (response.status) {
        setQuestions(response.data)
      }
    })
  }

  const fetchApplicationCheckList = () => {
    envAuditService
      .getApplicationChecklist(props.appDetails.id)
      .then(response => {
        // console.log("application checklist ", response)
        if (response.status) {
          setexistingChecklists(response.data)
          setmountChecklists(true)
        }
      })
  }

  const getApplicationAttachments = () => {
    const descriptions = [
      "Draft_Terms_of_Reference",
      "Checklist_Review_Document",
      "Meeting_Minutes",
      "Inspection Report",
    ]
    const atts = props.appDetails.application_attachments.filter(attachment =>
      descriptions.includes(attachment.description)
    )
    setstaffUploads(atts)
  }

  const decisionValueChange = value => {
    const commentsCodes = ["011", "012"]
    if (commentsCodes.includes(value)) {
      setshowComments(true)
    } else {
      setcomments("")
      setshowComments(false)
    }

    if (value == "017") {
      setshowDraftToRPreview(true)
    } else {
      setshowDraftToRPreview(false)
    }

    // console.log("Service ID")
    // console.log(props.appDetails.service_id)

    // Only show approval duration for Auth Plastics
    if (props.appDetails.service_id != 1) {
      setshowApprovalDuration(false)
    } else {
      if (value === "010") {
        setshowApprovalDuration(true)
      } else {
        setshowApprovalDuration(false)
      }
    }

    // show certificate preview
    if (value == "010") {
      setshowCertificatePreview(true)
    } else {
      setshowCertificatePreview(false)
    }
  }

  const handleCheckListChange = formData => {
    // console.log("checklist form data ", {name: name, value: value})
    setchecklistFormData(formData)
    // console.log("checklistFormData --> ", formData)
  }

  const submitCheckListReview = () => {
    const responses = questions.map(question => {
      const isCompliant = checklistFormData[`question-${question.id}`] === "Yes"
      const officerNotes = checklistFormData[`notes-${question.id}`] || ""

      return {
        application_id: props.appDetails.id,
        check_list_question_id: question.id,
        is_compliant: isCompliant,
        officer_notes: officerNotes,
      }
    })

    const submitData = {
      application_id: props.appDetails.id,
      data: responses,
    }

    // console.log("Form Responses:", responses);

    envAuditService.createApplicationChecklist(submitData).then(response => {
      console.log("submitted checklist review ", response)
    })
  }

  const handleSubmitButtonClicked = () => {
    if (applicationPhase == "phase 2") {
      submitCheckListReview()
    }
  }

  // RichText
  const handleEditorChange = content => {
    // console.log("HTML Content:", content)
    setapprovalConditions(content)
  }

  const handleToREditorChange = content => {
    // console.log("TOR Head-DM:", content)
    setapplicationToR(content)
  }

  // saveDraftTermsOfReference
  const saveDraftTermsOfReference = draftTor => {
    const data = {
      application_id: props.appDetails.id,
      application_tor: draftTor,
    }
    envAuditService.updateTermsOfReference(data).then(response => {
      // console.log("response save draft ToR", response)
    })
  }

  return (
    <>
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <div>
                <AvField
                  type="hidden"
                  name="application_id"
                  value={props.appDetails.id}
                />
                <AvField
                  type="hidden"
                  name="approval_conditions"
                  value={approvalConditions}
                />
                <AvField
                  type="hidden"
                  name="application_tor"
                  value={applicationToR}
                />
              </div>

              <div>
                {props.error && props.error == true ? (
                  <Row className="alert alert-danger">
                    <Col md="12">{props.message}</Col>
                  </Row>
                ) : null}

                {props.success && props.success == true ? (
                  <Row className="alert alert-success">
                    <Col md="8">{props.message}</Col>
                    <Col md="4">
                      <Link to="/officer-reviewed" style={{ float: "right" }}>
                        Back
                      </Link>
                    </Col>
                  </Row>
                ) : null}
              </div>

              {applicationPhase == "phase 2" ? (
                <Alert color="info">
                  Applicant has uploaded additional documents. Please check them
                  in the <b>Appplication Details</b> below
                </Alert>
              ) : null}

              <div className="mb-3">
                <AvField
                  //value={defaultValues.decision_code}
                  type="select"
                  name="decision_code"
                  label="Select Decision"
                  onChange={v => {
                    decisionValueChange(v.target.value)
                  }}
                  required
                  disabled={props.success}
                >
                  <option value="">--select Decision--</option>

                  {applicationPhase == "phase 1" ? (
                    <option value="017">
                      Propose for Terms of Reference Acquisition
                    </option>
                  ) : (
                    <option value="010">Propose to Approve</option>
                  )}

                  <option value="011">Propose to Reject</option>
                  <option value="008">Send Back</option>
                </AvField>
              </div>

              <Row className="mb-3">
                <label
                  htmlFor="txtAddress1Billing"
                  className="col-lg-3 col-form-label"
                >
                  Reason
                </label>
                <div className="col-lg-9">
                  <AvField
                    //value={defaultValues.reason}
                    type="textarea"
                    name="reason"
                    rows="2"
                    required
                    className="form-control"
                    disabled={props.success}
                  ></AvField>
                </div>
              </Row>

              {showApprovalDuration ? (
                <Row className="mb-3">
                  <div>
                    <AvField
                      type="number"
                      name="validity_days_from_approval"
                      label="Enter validity days from the date of approval (Eg. 365 days)"
                      rows="2"
                      required
                      className="form-control"
                    />
                  </div>
                </Row>
              ) : null}

              {showComments ? (
                <Row className="mb-3">
                  <label
                    htmlFor="txtAddress1Billing"
                    className="col-lg-3 col-form-label"
                  >
                    Comments to applicant
                  </label>
                  <div className="col-lg-9">
                    <AvField
                      //value={defaultValues.comment_to_applicant}
                      type="textarea"
                      name="comment_to_applicant"
                      rows="4"
                      required
                      className="form-control"
                      disabled={props.success}
                      onChange={v => {
                        setcomments(v.target.value)
                      }}
                    ></AvField>
                  </div>
                </Row>
              ) : null}

              {showCertificatePreview ? (
                <Row className="mb-3">
                  <Alert color="info">
                    Before submitting your review, please click on the preview
                    link below to see how the certificate will display after the
                    approval processes.
                  </Alert>
                  <a className="linkItem" target="_blank" href={certPreviewUrl}>
                    Preview Certificate{" "}
                    <i
                      className="fa fa-certificate"
                      title="Preview Certificate"
                    ></i>
                  </a>
                </Row>
              ) : null}

              {mountChecklists && applicationPhase == "phase 2" ? (
                <OfficerChecklistReviewForm
                  existingChecklists={existingChecklists}
                  handleChange={handleCheckListChange}
                  isReadOnly={true}
                />
              ) : null}
              {/* <a href="#" onClick={submitCheckListReview}>Test Submit CheckList</a> */}

              {/* RichText */}
              <div>
                {mountRichText && applicationPhase === "phase 2" ? (
                  <TinyMCEEditor
                    value={approvalConditions}
                    onChange={handleEditorChange}
                  />
                ) : null}

                {/* <h4>Preview:</h4>
                <div dangerouslySetInnerHTML={{ __html: editorContent }} /> */}
              </div>
              {/* show ToR Preview */}
              {applicationPhase == "phase 1" ? (
                <>
                  {/* Draft ToR Preview */}
                  {showDraftToRPreview ? (
                    <Row className="mb-3">
                      <Alert color="info">
                        Before submitting your review, please click on the
                        preview link below to see how the ToR draft will display
                        after the approval processes.
                      </Alert>
                      <a
                        className="linkItem"
                        target="_blank"
                        href={torPreviewUrl}
                      >
                        Preview ToR{" "}
                        <i
                          className="fa fa-certificate"
                          title="Preview Draft ToR"
                        ></i>
                      </a>
                    </Row>
                  ) : null}

                  {/* <Row className="mb-3">
                    <Alert color="info">
                      Before submitting your review, please click on the preview
                      link below to see how the ToR certificate will display
                      after the approval processes.
                    </Alert>
                    <a
                      className="linkItem"
                      target="_blank"
                      href={torPreviewUrl}
                    >
                      Preview ToR{" "}
                      <i
                        className="fa fa-certificate"
                        title="Preview Certificate"
                      ></i>
                    </a>
                  </Row> */}
                </>
              ) : (
                <Row className="mb-3">
                  <Alert color="info">
                    Click below to view final ToR Certificate.
                  </Alert>
                  <a className="linkItem" target="_blank" href={finalTorUrl}>
                    Final Terms of Reference{" "}
                    <i
                      className="fa fa-certificate"
                      title="ToR Certificate"
                    ></i>
                  </a>
                </Row>
              )}

              {mountToR &&
              props.appDetails.decision == "PROPOSE_FOR_TOR_ACQUISTION" || showDraftToRPreview ? (
                <TinyMCEEditor
                  label="Draft Terms of Reference"
                  value={applicationToR}
                  onChange={handleToREditorChange}
                  onBlur={saveDraftTermsOfReference}
                />
              ) : null}

              <div>
                <hr></hr>
                <label>Documents uploaded by officer</label>
                <ViewAttachments attachments={staffUploads} />
              </div>

              {props.loading && props.loading === true ? (
                <Link
                  to="#"
                  className="spinner-border text-info"
                  style={{ float: "right" }}
                />
              ) : (
                <div className="mt-5">
                  <button
                    className="btn btn-lg btn-primary col-12"
                    disabled={props.success}
                    onClick={handleSubmitButtonClicked}
                  >
                    Submit Review
                  </button>
                </div>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}

export default HeadFormEnvAudit
